/* eslint-disable */

import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import http from '../../Interceptor/Interseptor'
import {message} from 'antd'
import BASE_MANAGE from '../../BaseComponent/BASEMANAGE'
import BASE_PUBLIC from '../../BaseComponent/BASEPUBLIC'
import USER_MANAGE from '../../BaseComponent/USERMANAGE'
import SearchableCombo from '../../BaseComponent/searchableCombo'
import Select from 'react-select'

class EditTerminal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      terminalID: 0,
      code: '',
      brand: '',
      serialNumber: '',
      externalId: null,
      error: '',
      accounts: [],
      drivers: [],
      accountId: 0,
      typeAccountTitle: '',
      assigneeName: null,
      assignee: null,
      terminal: {}
    }
  }

  componentDidMount() {
    this.getAccounts()
    Promise.all([this.getDriver()]).then(() => {
      this.getDetailEntity()
    })
    // let TerminId=this.props.match.params.id;
  }

  getDetailEntity = () => {
    let TerminId = this.props.match.params.id
    return http
      .get(`${BASE_MANAGE.BASE_MANAGE_PAYMENT_GET_ID_TERMINAL}/get?terminalId=${TerminId}`, {})
      .then((response) => {
        if (response.data.error == null) {
          // alert(JSON.stringify(this.state.drivers))

          let findSelectedDrivers = this.state.drivers.find((item) => item.personId === response.data.object.assignee)
          if (findSelectedDrivers) {
            this.setState({assignee: findSelectedDrivers})
          }

          this.setState({
            terminal: response.data.object,
            terminalID: response.data.object.terminalId,
            code: response.data.object.code,
            brand: response.data.object.brand,
            externalId: response.data.object.externalId,
            serialNumber: response.data.object.serialNumber,
            accountId: response.data.object.typeAccountId,
            assigneeName: response.data.object.assigneeName,
            typeAccountId: response.data.object.typeAccountId
          })
        } else {
          message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  getAccounts = () => {
    http
      .get(`${BASE_PUBLIC.BASE__PUBLIC_HASTERMINAL_ACCOUNTS}`, {})
      .then((res) => {
        if (res.data.error === null) {
          this.setState({
            accounts: res.data.object
          })
        } else {
          message.error('خطای ' + res.data.errorCode + ' : ' + res.data.description)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }
  getDriver = () => {
    return http
      .get(`${USER_MANAGE.USER_MANAGE_LIST_DRIVER}`, {})
      .then((res) => {
        if (res.data.error === null) {
          let drivers = res.data.object
          for (const element of drivers) {
            element['value'] = element.personId
            element['label'] = element.personId + ' - ' + element.name
          }
          this.setState({
            drivers
          })
        } else {
          message.error('خطای ' + res.data.errorCode + ' : ' + res.data.description)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }
  changeInputs = (e) => {
    let name = e.target.name
    let value = e.target.value
    this.setState({
      [name]: value
    })
  }
  changeInputsnum = (e) => {
    let name = e.target.name
    let value = parseInt(e.target.value)
    this.setState({
      [name]: value
    })
  }
  onChangeSelectDriver = (e) => {
    let value = parseInt(e.target.value)

    this.setState({
      assignee: value
    })
  }
  onChangeSelectAccount = (e) => {
    let value = parseInt(e.target.value)

    this.setState({
      accountId: value,
      typeAccountId: value
    })
  }
  onEditClick = () => {
    let terminalId = this.state.terminalID
    let code = this.state.code
    let externalId = +this.state.externalId
    let brand = this.state.brand
    let serialNumber = this.state.serialNumber
    let typeAccountId = this.state.accountId
    let assignee = this.state.assignee !== null ? this.state.assignee.personId : ''

    let codeError = false
    let brandError = false
    let serialNumberError = false
    let typeAccountIdError = false
    let formError = false

    if (code === 0) {
      formError = true
      codeError = true
      message.error('کد ترمینال را وارد کنید')
    } else {
      if (!codeError) {
      }
    }

    if (brand === '') {
      formError = true
      brandError = true
      message.error('برند را وارد کنید')
    } else {
      if (!brandError) {
      }
    }
    if (serialNumber === '') {
      formError = true
      serialNumberError = true
      message.error('شماره سریال را وارد کنید')
    } else {
      if (!serialNumberError) {
      }
    }
    if (typeAccountId === '') {
      formError = true
      typeAccountIdError = true
      message.error('روش پرداخت  را انتخاب کنید')
    } else {
      if (!typeAccountIdError) {
      }
    }

    if (!formError) {
      let data = {
        terminalId,
        code,
        brand,
        externalId,
        serialNumber,
        typeAccountId,
        assignee
      }

      http
        .put(`${BASE_MANAGE.BASE_MANAGE_PAYMENT_UPDATE_TERMINAL}`, data)
        .then((response) => {
          if (response.data.error == null) {
            message.success('ترمینال ویرایش  شد')
            this.props.history.push('/Base/payment/terminals')
          } else {
            message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  getValueDriver = (assignee) => {
    this.setState({
      assignee
    })
  }

  onSubmit = (e) => {
    e.preventDefault()
  }

  render() {
    let {terminal, drivers, accounts} = this.state
    return (
      <div className="rtl">
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>اطلاعات پایه</Link>
            </li>
            <li>
              <Link to={'/Payment'}>پرداخت</Link>
            </li>
            <li>ویرایش ترمینال</li>
          </ul>
          <div className="mt-2 bg-white container-fluid p-3">
            <div className="row">
              <div className="col-xs-12 col-sm-6 col-md-3">
                <label htmlFor="name">
                  کد ترمینال<span className="requireFiled">*</span>
                </label>
                <input type="number" name="code" className="form-control" disabled={true} value={this.state.code} />
              </div>
              <div className="col-xs-12 col-sm-6 col-md-3">
                <label htmlFor="brand">
                  برند<span className="requireFiled">*</span>
                </label>
                <input
                  type="text"
                  name="brand"
                  className="form-control"
                  onChange={this.changeInputs}
                  placeholder="برند را وارد کنید"
                  value={this.state.brand}
                />
              </div>
              <div className="col-xs-12 col-sm-6 col-md-3">
                <label htmlFor="serialNumber">
                  {' '}
                  شماره سریال <span className="requireFiled">*</span>
                </label>
                <input
                  type="text"
                  name="serialNumber"
                  className="form-control"
                  placeholder="شماره سریال  را وارد کنید"
                  onChange={this.changeInputs}
                  value={this.state.serialNumber}
                />
              </div>

              <div className="col-xs-12 col-sm-6 col-md-3">
                <label htmlFor="externalId"> External Id</label>
                <input
                  type="number"
                  name="externalId"
                  className="form-control"
                  placeholder="External Id را وارد کنید"
                  onChange={this.changeInputs}
                  value={this.state.externalId}
                />
              </div>

              <div className="col-xs-12 col-sm-6 col-md-3">
                <label htmlFor="روش پرداخت"> روش پرداخت </label>
                <select
                  className="custom-select"
                  id="روش پرداخت"
                  onChange={this.onChangeSelectAccount}
                  name="typeAccountTitle"
                  tabIndex="2"
                  placeholder="روش پرداخت را انتخاب کنید"
                >
                  {accounts.map((acount, index) => (
                    <option
                      selected={this.state.typeAccountId === acount.id ? true : false}
                      value={acount.id}
                      key={index}
                    >
                      {acount.title}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-xs-12 col-sm-6 col-md-3 mt-sm-2">
                <label htmlFor="راننده"> رساننده </label>
                <Select
                  value={this.state.assignee}
                  onChange={this.getValueDriver}
                  options={this.state.drivers}
                  isClearable={true}
                  placeholder=""
                />

                {/*<label htmlFor="راننده"> راننده </label>*/}
                {/*<select className="custom-select" id="راننده" onChange={this.onChangeSelectDriver}*/}
                {/*        name="assignee"*/}
                {/*        tabIndex='2'*/}
                {/*        placeholder="راننده را انتخاب کنید"*/}
                {/*>*/}
                {/*    <option value={''}>---------</option>*/}

                {/*    {drivers.map((driver,index)=>(<option*/}
                {/*            value={driver.personId}*/}
                {/*            selected={this.state.assignee === driver.personId ? true : false}*/}

                {/*            key={index}*/}

                {/*        > {driver.name} </option>)*/}
                {/*    )}*/}
                {/*</select>*/}
                {/*<label htmlFor="روش پرداخت"> رساننده </label>*/}
                {/*<select className="custom-select" id="assignee" onChange={this.onChangeSelectDriver}*/}
                {/*        name="assignee"*/}
                {/*        tabIndex='2'*/}
                {/*        placeholder="راننده را انتخاب کنید"*/}
                {/*>*/}
                {/*    <option*/}
                {/*        value={null}>---------</option>*/}
                {/*    {drivers.map((driver,index)=>(<option*/}
                {/*            value= {driver.personId}*/}
                {/*            key={index}*/}
                {/*        >{driver.name}</option>)*/}
                {/*    )}*/}
                {/*</select>*/}
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-sm-6 col-md-3 mt-sm-2">
                <button className="btn mx-0" style={{background: '#f7941e'}} onClick={this.onEditClick}>
                  ویرایش ترمینال
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default EditTerminal
